import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../modules/infra/i18n';

const Maintenance = ({ children, onDismiss }) => (
  <div className="c-alert c-alert_warning u-fontsize-small">
    <span>{children}</span>
    <button className="c-btn c-btn--blank c-btn--link u-pl-" type="button" onClick={onDismiss}>
      {t('common:buttons.dismiss')}
    </button>
  </div>
);

Maintenance.propTypes = {
  children: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default Maintenance;
